import Billing from '@web-solutions/module-billing';

import { Purchase } from 'core/interfaces/billing';

export const processPayment = async (
  purchase: Purchase,
  recurlyId: string,
  threeDSecureActionTokenId?: string
) => {
  try {
    const { payment_system_project: projectType } = Billing.getPaymentParams();
    const requestBody = {
      itemCode: recurlyId,
      currency: 'USD',
      projectType,
      threeDSecureActionTokenId,
    };
    const response = await Billing.oneTimePurchaseRecurly(requestBody);

    return response;
  } catch (e) {
    //@ts-ignore
    if (e?.data?.three_d_secure_action_token_id) {
      //@ts-ignore
      e.is3DS = true;
      throw e;
    }

    //@ts-ignore
    e.isProcessPaymentError = true;
    throw e;
  }
};
